import React, { useState, useEffect, useRef } from "react";
import Control from "./Control";
import { DateTime } from "luxon";

const DateRangePicker = ({
  name,
  label,
  placeholder,
  value = {},
  onChange,
  className,
}) => {
  // États locaux pour les dates de début et fin
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const timeoutRef = useRef(null);

  console.log("value", value);

  // Initialiser les valeurs à partir de la prop value
  useEffect(() => {
    if (value && typeof value === "object") {
      // Extraire les dates depuis l'objet value
      const dateDebutRange = value.from;
      const dateFinRange = value.to;

      if (dateDebutRange) {
        setStartDate(dateDebutRange || "");
        setEndDate(dateFinRange || "");
      } else if (dateFinRange) {
        setStartDate(dateFinRange || "");
        setEndDate(dateFinRange || "");
      }
    }
  }, [value]);

  // Fonction pour construire l'objet de sortie
  const buildOutputObject = (fromDate, toDate) => {
    const result = {};

    if (fromDate || toDate) {
      // Pour l'instant, on utilise contrat_date_debut comme clé principale
      // Cela peut être étendu plus tard pour supporter d'autres types de dates

      if (fromDate) {
        result.from = fromDate;
      }

      if (toDate) {
        result.to = toDate;
      }
    }

    return result;
  };

  // Fonction pour valider qu'une date est complète et valide
  const isValidCompleteDate = (dateString) => {
    if (!dateString || dateString.length !== 10) return false;
    // Vérifier le format strict YYYY-MM-DD avec regex
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(dateString)) return false;
    // Vérifier que c'est une date valide avec Luxon
    const dt = DateTime.fromISO(dateString);
    return dt.isValid;
  };

  // Fonction pour notifier les changements avec debounce
  const notifyChange = (fromDate, toDate) => {
    const outputValue = buildOutputObject(fromDate, toDate);

    // Annuler le timeout précédent s'il existe
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Ne déclencher onChange que si au moins une date est valide et complète
    const hasValidFromDate = fromDate && isValidCompleteDate(fromDate);
    const hasValidToDate = toDate && isValidCompleteDate(toDate);

    if (onChange && (hasValidFromDate || hasValidToDate)) {
      // Attendre 800ms avant de déclencher onChange pour laisser le temps de saisir
      timeoutRef.current = setTimeout(() => {
        // Simuler un événement natif
        const syntheticEvent = {
          target: {
            value: outputValue,
          },
        };

        onChange(syntheticEvent);
      }, 800);
    }
  };

  // Gestionnaire pour la date de début
  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    setStartDate(newStartDate);
    notifyChange(newStartDate, endDate);
  };

  // Gestionnaire pour la date de fin
  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    setEndDate(newEndDate);
    notifyChange(startDate, newEndDate);
  };

  return (
    <div className={`date-range-picker ${className || ""}`}>
      <div className="row">
        <div className="col-6">
          <Control
            type="date"
            name={`${name}_start`}
            label="Entre le"
            placeholder="Date de début"
            value={startDate}
            change={handleStartDateChange}
            className="mb-2"
          />
        </div>
        <div className="col-6">
          <Control
            type="date"
            name={`${name}_end`}
            label="Et le"
            placeholder="Date de fin"
            value={endDate}
            change={handleEndDateChange}
            className="mb-2"
          />
        </div>
      </div>

      {/* Affichage du résumé si des dates sont sélectionnées */}
      {(startDate || endDate) && (
        <div className="mt-2 text-muted small">
          <i className="fas fa-info-circle mr-1"></i>
          {startDate && endDate ? (
            <>
              Du {startDate} au {endDate}
            </>
          ) : startDate ? (
            <>À partir du {startDate}</>
          ) : (
            <>Jusqu'au {endDate}</>
          )}
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
